import { createApp } from 'vue';
import CalculatorWrap from 'ewi-ui/components/3-organisms/Calculator/CalculatorWrap.vue';
import { createPinia } from 'pinia';

const pinia = createPinia();
const apps = [];
window.addEventListener('pageshow', (e) => {
  const allCalculators = document.getElementsByClassName('m-calculator');

  for (let i = 0; i < allCalculators.length; i++) {
    let mountElementDataset = allCalculators[i].dataset;
    const app = createApp(CalculatorWrap, {
      config: mountElementDataset,
      componentId: i,
    });

    app.use(pinia);
    app.mount(allCalculators[i]);
    apps.push(app);
  }
});
